import axios from "axios";

// Base URL of the wisefinserv admin (Next.js) backend.
// Set via .env.development / .env.production (REACT_APP_API_URL).
const API_BASE_URL = `https://admin.wisefinserv.com` || "http://localhost:3000";

const api = axios.create({
  baseURL: `${API_BASE_URL}/api/wisefinserv`,
});

export const fetchBlogs = async () => {
  const { data } = await api.get("/blogs");
  return data;
};

export const fetchBlogById = async (id) => {
  const { data } = await api.get(`/blogs/${id}`);
  return data.blog;
};

export const fetchBlogBySlug = async (slug) => {
  const blogs = await fetchBlogs();
  return blogs.find((blog) => blog.slug === slug) || null;
};

export const fetchBlogCategories = async () => {
  const { data } = await api.get("/blog-categories");
  return data;
};

export const formatBlogDate = (blog) => {
  const raw = blog?.publishedAt || blog?.createdAt;
  if (!raw) return "";
  return new Date(raw).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export default api;
